module.exports = __webpack_public_path__ + "static/media/about1.0f9fae69.avif";